<div *ngIf="notes.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
    <span class="no-messages-text hint-text pt-32">There are no notes</span>
</div>

<cdk-virtual-scroll-viewport [itemSize]="84" minBufferPx="1000" maxBufferPx="1000" class="note-list" *fuseIfOnDom >
    <note-list-item class="note-list-item clickable list-item" *cdkVirtualFor="let note of notes; trackBy: trackByFn" [note]="note" [parent]="_parent" [readOnly]="readOnly" [selectable]="!inWidget" (click)="selectNote(note)" (dblclick)="readNote(note)"
                         [ngClass]="{'selected':note?.id == currentNote?.id}"
                         >
    </note-list-item>
</cdk-virtual-scroll-viewport>